import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const CM360Icon = {
  name: 'CM360Icon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 860 820",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-cm360"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M296 276C303.706 275.841 311.236 274.699 319 275.039C359.313 276.805 399.602 287.871 435 307.312C451.357 316.295 464.83 328.439 480 339C478.142 334.09 474.952 329.84 472.873 325C467.967 313.58 465.495 301.417 466.039 289C468.038 243.433 511.062 207.362 556 212.174C569.407 213.609 583.176 219.249 594 227.159C599.486 231.168 603.815 236.338 609 240.675C617.142 247.487 626.883 253.179 637 256.48C673.894 268.517 717.491 253.644 737.547 220C749.092 200.633 751.843 177.912 747.83 156C743.091 130.119 723.697 111.709 704 96.0038C658.48 59.7094 602.774 42 545 42C448.164 42 358.749 99.9149 318.309 188C310.289 205.467 304.176 224.098 300.611 243C298.548 253.942 298.024 265.098 296 276z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("path", {
        attrs: {
          d: "M737 129C741.926 142.536 749.306 154.073 749.961 169C751.972 214.88 716.232 258.817 669 260.961C655.274 261.584 641.371 258.731 629 252.742C622.463 249.577 616.709 244.581 610 242C621.205 260.157 629.424 277.027 627.911 299C625.107 339.718 584.804 377.873 543 373.83C528.601 372.438 513.709 367.948 502 359.239C491.55 351.466 483.125 340.901 473 332.614C452.794 316.076 429.635 301.795 405 292.861C381.992 284.517 357.502 277.807 333 276.089C232.644 269.056 134.044 322.418 88.7531 413C78.7117 433.083 70.1792 454.725 66.4352 477C54.6206 547.291 67.531 619.078 110.63 677C117.218 685.855 124.57 693.772 131.871 702C134.357 704.801 136.135 708.251 139.054 710.651C179.51 743.924 243.866 737.443 274.279 694C279.707 686.245 283.757 677.296 285.714 668C289.598 649.542 286.083 630.705 277.73 614C274.249 607.038 266.994 600.321 265 593C256.998 587.363 250.387 579.122 245.004 571C236.723 558.507 231.179 542.118 231.179 527C231.179 468.149 299.843 426.856 351 456.465C360.987 462.245 369.394 470.586 376 480C384.359 481.907 393.032 492.196 400 497.37C413.589 507.461 428.628 515.653 444 522.691C502.844 549.635 573.401 551.165 634 528.947C656.379 520.742 677.901 509.407 697 495.105C781.472 431.848 816.966 321.938 788 221C781.048 196.776 770.322 173.975 756.333 153C750.837 144.759 745.049 134.925 737 129z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("path", {
        attrs: {
          d: "M542 212.424C512.706 216.271 487.486 230.229 474.32 258C464.005 279.759 464.03 307.445 474.809 329C489.44 358.258 522.451 376.607 555 372.715C588.279 368.734 616.977 346.286 625.102 313C635.806 269.146 609.02 223.126 564 214.004C556.972 212.58 549.135 211.488 542 212.424z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("path", {
        attrs: {
          d: "M302 447.439C289.156 449.445 276.7 453.928 266 461.44C236.996 481.802 225.026 519.474 236.09 553C240.447 566.205 248.313 577.096 257.91 586.961C266.761 596.057 277.671 602.411 290 605.711C300.309 608.469 312.434 609.085 323 607.572C335.291 605.811 346.606 601.755 357 594.921C405.185 563.241 402.553 488.033 354 458.065C345.998 453.126 337.225 449.983 328 448.261C319.697 446.711 310.386 446.129 302 447.439z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("path", {
        attrs: {
          d: "M377 479C378.903 484.02 382.377 488.155 384.68 493C390.434 505.106 393.553 518.586 392.961 532C391.018 575.967 349.478 611.958 306 608.911C289.951 607.786 278.395 599.448 264 594C274.021 609.165 284.95 624.204 286.829 643C291.565 690.357 250.564 728.787 205 731.911C189.099 733 173.23 729.306 159 722.191C153.073 719.228 148.001 714.671 142 712C147.395 721.389 160.27 728.694 169 734.856C198.17 755.446 232.831 769.255 268 775.08C350.388 788.727 437.265 762.884 494.91 701C514.162 680.333 529.937 656.672 541.691 631C554.217 603.644 560.643 573.86 563 544C551.462 544 539.487 544.923 528 543.83C491.595 540.366 457.215 530.156 425 512.691C413.697 506.564 403.167 499.187 393 491.349C387.751 487.302 382.997 481.796 377 479z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      })
    ]);
  }
};

export default CM360Icon;